
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Button } from "../components";
export const scope = "react";
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  scope
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`MDX kitchen sink`}</h1>
    <h2>{`Headers`}</h2>
    <h1>{`H1`}</h1>
    <h2>{`H2`}</h2>
    <h3>{`H3`}</h3>
    <h4>{`H4`}</h4>
    <h5>{`H5`}</h5>
    <h6>{`H6`}</h6>
    <h2>{`Paragraph`}</h2>
    <p>{`Vel malis aliquid at, no est saepe legere. Ex usu possit adipiscing, cu vim everti intellegat deterruisset. Ei usu doming fabellas tacimates, causae virtute cum in. Ius alia eirmod cetero ei.`}</p>
    <h2>{`React component`}</h2>
    <Button onClick={() => {
      console.log("Hello MDX!");
    }} mdxType="Button">
  {scope === "react" ? "This logs to console" : "This do nothing"}
    </Button>
    <h2>{`Emoji`}</h2>
    <p>{`❤️`}</p>
    <h2>{`Emphasis`}</h2>
    <p>{`Emphasis, aka italics, with `}<em parentName="p">{`asterisks`}</em>{` or `}<em parentName="p">{`underscores`}</em>{`.`}</p>
    <p>{`Strong emphasis, aka bold, with `}<strong parentName="p">{`asterisks`}</strong>{` or `}<strong parentName="p">{`underscores`}</strong>{`.`}</p>
    <p>{`Combined emphasis with `}<strong parentName="p">{`asterisks and `}<em parentName="strong">{`underscores`}</em></strong>{`.`}</p>
    <p>{`Strikethrough uses two tildes. `}<del parentName="p">{`Scratch this.`}</del></p>
    <h2>{`Lists`}</h2>
    <ol>
      <li parentName="ol">{`First ordered list item`}</li>
      <li parentName="ol">{`Another item`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Unordered sub-list.`}</li>
    </ul>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Actual numbers don't matter, just that it's a number`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Ordered sub-list`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`And another item.`}</p>
        <p parentName="li">{`You can have properly indented paragraphs within list items. Notice the blank line above, and the leading spaces (at least one, but we'll use three here to also align the raw Markdown).`}</p>
        <p parentName="li">{`To have a line break without a paragraph, you will need to use two trailing spaces.
Note that this line is separate, but within the same paragraph.
(This is contrary to the typical GFM line break behaviour, where trailing spaces are not required.)`}</p>
      </li>
    </ol>
    <ul>
      <li parentName="ul">{`Unordered list can use asterisks`}</li>
    </ul>
    <ul>
      <li parentName="ul">{`Or minuses`}</li>
    </ul>
    <ul>
      <li parentName="ul">{`Or pluses`}</li>
    </ul>
    <h2>{`Links`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.google.com"
      }}>{`I'm an inline-style link`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://www.google.com",
        "title": "Google's Homepage"
      }}>{`I'm an inline-style link with title`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://www.mozilla.org"
      }}>{`I'm a reference-style link`}</a></p>
    <p><a parentName="p" {...{
        "href": "../blob/master/LICENSE"
      }}>{`I'm a relative reference to a repository file`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://slashdot.org"
      }}>{`You can use numbers for reference-style link definitions`}</a></p>
    <p>{`Or leave it empty and use the `}<a parentName="p" {...{
        "href": "http://www.reddit.com"
      }}>{`link text itself`}</a>{`.`}</p>
    <p>{`URLs and URLs in angle brackets will automatically get turned into links.
`}<a parentName="p" {...{
        "href": "http://www.example.com"
      }}>{`http://www.example.com`}</a>{` or `}<a parentName="p" {...{
        "href": "http://www.example.com"
      }}>{`http://www.example.com`}</a>{` and sometimes
example.com (but not on Github, for example).`}</p>
    <p>{`Some text to show that the reference links can follow later.`}</p>
    <h2>{`Images`}</h2>
    <p>{`Inline-style:
`}<img parentName="p" {...{
        "src": "../assets/logo/logo.svg",
        "alt": "alt text",
        "title": "Logo Title Text 1"
      }}></img></p>
    <p>{`Reference-style:
`}<img parentName="p" {...{
        "src": "../assets/logo/logo.svg",
        "alt": "alt text",
        "title": "Logo Title Text 2"
      }}></img></p>
    <h2>{`Code and Syntax Highlighting`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var s = "JavaScript syntax highlighting";
alert(s);
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`No language indicated, so no syntax highlighting in Markdown Here.
But let's throw in a <b>tag</b>.
`}</code></pre>
    <h2>{`Tables`}</h2>
    <p>{`Colons can be used to align columns.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Tables`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Are`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`Cool`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`col 3 is`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`right-aligned`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`\\$1600`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`col 2 is`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`centered`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`\\$12`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`zebra stripes`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`are neat`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`\\$1`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`There must be at least 3 dashes separating each header cell. The outer pipes (|) are optional, and you don't need to make the raw Markdown line up prettily. You can also use inline Markdown.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Markdown`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Less`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Pretty`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Still`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`renders`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`nicely`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Blockquotes`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Blockquotes are very handy in email to emulate reply text.
This line is part of the same quote.`}</p>
    </blockquote>
    <p>{`Quote break.`}</p>
    <blockquote>
      <p parentName="blockquote">{`This is a very long line that will still be quoted properly when it wraps. Oh boy let's keep writing to make sure this is long enough to actually wrap for everyone. Oh, you can `}<em parentName="p">{`put`}</em>{` `}<strong parentName="p">{`Markdown`}</strong>{` into a blockquote.`}</p>
    </blockquote>
    <h2>{`Inline HTML`}</h2>
    <dl>
  <dt>Definition list</dt>
  <dd>Is something people use sometimes.</dd>
  <dt>Markdown in HTML</dt>
  <dd>Does *not* work **very** well. Use HTML <em>tags</em>.</dd>
    </dl>
    <h2>{`Horizontal Rule`}</h2>
    <hr></hr>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;